import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../../components";

import androidIcon from "../../images/android.png";
import iosIcon from "../../images/ios.png";
import styles from "./style.module.scss";
const SystemMethodTabs = ({
  nowSystemTab,
  setNowSystemTab,
  nowMethod,
  setNowMethod,
  systemEnum,
  installMethodEnum,
}: {
  nowSystemTab: string;
  setNowSystemTab: (val: string) => void;
  nowMethod: string;
  setNowMethod: (val: string) => void;
  systemEnum: { [x: string]: string };
  installMethodEnum: { [x: string]: string };
}) => {
  const { t } = useTranslation();
  const tabItems = [
    {
      label: "iOS",
      key: systemEnum.IOS,
      icon: iosIcon,
    },
    {
      label: "Android",
      key: systemEnum.ANDROID,
      icon: androidIcon,
    },
  ];
  const methodButtons = [
    {
      label: t("installguide.qrcode"),
      key: installMethodEnum.QRCODE,
    },
    {
      label: t("installguide.manual"),
      key: installMethodEnum.MANUAL,
    },
  ];
  return (
    <div className={styles.container}>
      <div className={styles.systemTabs}>
        {tabItems.map((item) => (
          <div
            key={item.key}
            className={`${styles.tabItem} ${
              item.key === nowSystemTab ? styles.active : ""
            }`}
            onClick={() => setNowSystemTab(item.key)}
          >
            <img src={item.icon} alt={item.key} className={styles.systemIcon} />
            {item.label}
          </div>
        ))}
      </div>

      <div className={styles.methodBtns}>
        {methodButtons.map((item) => (
          <CustomButton
            key={item.key}
            onClick={() => setNowMethod(item.key)}
            type={item.key === nowMethod ? "primary" : "default"}
          >
            {item.label}
          </CustomButton>
        ))}
      </div>
    </div>
  );
};

export default SystemMethodTabs;
